interface TouchEndSwiper {
    el?: HTMLElement | string | null
    destroyed?: boolean
    onTouchEnd?: (event: Event) => void
    on?: (event: 'destroy', handler: () => void) => void
}

/**
 * Swiper 14 hears a gesture's touchend/touchcancel only on `document`. Panel content that
 * stops those events in React (FileEmbed media, audio/video controls, ...) hides the finger
 * lift from Swiper, which then leaves the panels parked mid-drag. Swiper 6 listened on its
 * own element, below React's root, so deliver the end there again. Swiper clears the touch
 * id on the first delivery, so the document copy of the same event is ignored.
 */
export const deliverSwiperTouchEndFromElement = (swiper: TouchEndSwiper) => {
    const el = swiper.el
    if (!el || typeof el === 'string') return

    const handleTouchFinish = (event: TouchEvent) => {
        if (swiper.destroyed) return
        swiper.onTouchEnd?.(event)
    }

    el.addEventListener('touchend', handleTouchFinish, { passive: true })
    el.addEventListener('touchcancel', handleTouchFinish, { passive: true })
    swiper.on?.('destroy', () => {
        el.removeEventListener('touchend', handleTouchFinish)
        el.removeEventListener('touchcancel', handleTouchFinish)
    })
}
